import React, { Component } from 'react';
import { Button, Alert, Table, Badge, Form, Modal, Row, Col } from 'react-bootstrap';
import { GoKey, GoTrash } from "react-icons/go";
import Select from 'components/controls/select';
import ConfirmModal from 'components/controls/confirmModal';
import Utils from 'context/utils';

import Clipboard from "../workflow/generic/controls/common/clipboard";

class ApiKeyConfirmModal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if ( !this.props.apiKey ) {
      return <></>;
    }
    return (
      <Modal
        onHide={this.props.onHide}
        show={this.props.show}
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            API Key Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>
                <div className="d-flex">
                  <span style={{"margin-top": "6px"}}>
                    <strong>Key</strong>
                  </span>
                  &nbsp;&nbsp;
                  <Clipboard text={this.props.apiKey.key} />
                </div>
              </Form.Label>
              <Row>
                <Col>
                  <Alert variant="info" style={{overflowWrap: "break-word"}}>
                    {this.props.apiKey.key}
                  </Alert>
                </Col>
              </Row>
              <Form.Text muted>
                Make sure to copy the key and save it in secure location.
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={this.props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

class AddApiKeyModal extends Component {
  constructor(props) {
    super(props);

    this.roleOptions = [
      { value: 'read', label: 'Read' },
      { value: 'write', label: 'Write' },
      { value: 'admin', label: 'Admin' }
    ];

    this.state = {
      apiKey: {
        role: this.roleOptions[0],
        description: ""
      }
    };

    this.form = React.createRef();
  }

  onEnter = () => {
    this.setState({
      apiKey: {
        role: this.roleOptions[0],
        description: ""
      }
    });
  }

  handleAddApiKey = () => {
    // Check form validity
    if ( !this.form.current.reportValidity() ) {
      return;
    }

    // Initiate processing
    const apiKey = {
      role: this.state.apiKey.role.value,
      description: this.state.apiKey.description
    };
    this.props.handleAddApiKey(apiKey);

    // Close modal
    this.props.onHide();
  }

  render() {
    return (
      <Modal
        onEnter={this.onEnter}
        onHide={this.props.onHide}
        show={this.props.show}
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Add New API Key
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form ref={this.form}>
            <Form.Group>
              <Form.Label>
                <strong>Role</strong> <span className="text-muted">(required)</span>
              </Form.Label>
              <Row>
                <Col sm={4}>
                  <Select
                    options={this.roleOptions}
                    value={this.state.apiKey.role}
                    onChange={(option) => {
                      let apiKey = this.state.apiKey;
                      apiKey.role = option;
                      this.setState({apiKey: apiKey});
                    }}
                  />
                </Col>
              </Row>
              <Form.Text muted>
                Selecting the right role is critical to make sure that target's data is properly protected.
              </Form.Text>
              <Form.Text muted>
                The following roles are supported:
              </Form.Text>
              <Form.Text muted>
                <ul>
                  <li><strong>Read</strong> Provides read-only access to the target, its properties, and child objects.</li>
                  <li><strong>Write</strong> Allows modifying the target, its properties, and child objects.</li>
                  <li><strong>Admin</strong> Empowers users to administer the the target, and its child objects (full control).</li>
                </ul>
              </Form.Text>
            </Form.Group>
            <hr/>

            <Form.Group>
              <Form.Label>
                <strong>Description</strong>
              </Form.Label>
              <Row>
                <Col sm={9}>
                  <Form.Control
                    type="text"
                    size="sm"
                    autoFocus
                    value={this.state.apiKey.description}
                    onChange={(event) => {
                      let apiKey = this.state.apiKey;
                      apiKey.description = event.target.value;
                      this.setState({apiKey: apiKey});
                    }}
                  />
                </Col>
              </Row>
              <Form.Text muted>
                Provide optional description to be able to differentiate API keys belonging to the same target.
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={this.props.onHide}>Close</Button>
          <Button variant="success" onClick={this.handleAddApiKey}>Add</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

class ApiKey extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleting: false,
      deletingError: null,
      confirmModalShow: false
    };
  }

  handleDelete() {
    this.setState({
      deleting: true,
      deletingError: null
    });
    this.props.apiKeysInterface.setModifying(true);

    const apiKeyId = this.props.apiKey.id;
    this.props.app.api.apiKeysIdDelete(apiKeyId)
      .then(_ => {
        this.setState({deleting: false});
        this.props.apiKeysInterface.setModifying(false);
        this.props.apiKeysInterface.loadApiKeys();
      }, error => {
        this.setState({
          deleting: false,
          deletingError: Utils.errorMessage(error)
        });
        this.props.apiKeysInterface.setModifying(false);
      });
  }

  render() {
    return (
      <>
        <tr>
          <td>
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-baseline">
                {/* Bare SVG, not wrapped in a span: a wrapping element gives the glyph its OWN small
                    inline formatting context, whose invisible strut baseline sits a few px away from
                    where the glyph's own box lands — it otherwise reads as floating off the row's
                    shared baseline. Unwrapped, it aligns exactly like the identity glyphs. */}
                <GoKey style={{"width": "20px"}}/>
                &nbsp;&nbsp;
                <code>
                  <strong>
                    {this.props.apiKey.key_prefix}
                  </strong>
                </code>
                &nbsp;&nbsp;
                <Badge variant="secondary" className="title-tag-badge">{this.props.apiKey.role}</Badge>
                {this.props.apiKey.description &&
                  <>
                    &nbsp;&nbsp;
                    {this.props.apiKey.description}
                  </>
                }
              </div>

              <div className="ml-auto">
                {!this.props.apiKeysInterface.modifying &&
                  <Button
                    variant="danger"
                    className="btn-icon"
                    onClick={() => this.setState({confirmModalShow: true})}
                    ><GoTrash /></Button>
                }
              </div>
            </div>
          </td>
        </tr>
        {this.state.deleting &&
          <tr>
            <td style={{padding: "0px"}}>
              <div>
                <Alert variant="primary">
                  Deleting API key...
                </Alert>
              </div>
            </td>
          </tr>
        }
        {this.state.deletingError &&
          <tr>
            <td style={{padding: "0px"}}>
              <div>
                <Alert variant="warning">
                  {this.state.deletingError}
                </Alert>
              </div>
            </td>
          </tr>
        }

        <ConfirmModal
          show={this.state.confirmModalShow}
          onHide={() => this.setState({confirmModalShow: false})}
          onConfirm={() => this.handleDelete()}
          title="Delete API Key"
          body={
            <>
              Are you sure you want to delete API key <strong>{this.props.apiKey.key_prefix}</strong>? Any
              integration using this key will immediately stop working.
            </>
          }
        />
      </>
    );
  }
}

export default class ApiKeys extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modifying: false,
      creatingApiKey: false,
      creatingApiKeyError: null,
      addApiKeyModalShow: false,
      apiKeys: null,
      apiKey: null,
      setModifying: this.setModifying,
      loadApiKeys: this.loadApiKeys,
      setAddApiKeyModalShow: (show) => {
        this.setState({addApiKeyModalShow: show});
      },
      apiKeyConfirmModalShow: false,
      setApiKeyConfirmModalShow: (show) => {
        this.setState({apiKeyConfirmModalShow: show});
      }
    };
  }

  componentDidMount() {
    this.loadApiKeys();
  }

  setModifying = (modifying) => {
    this.setState({modifying: modifying});
  }

  loadApiKeys = () => {
    this.props.app.api.apiKeysTargetTargetIdGet(this.props.target, this.props.targetId)
      .then(response => {
        this.setState({
          apiKeys: response.data.api_keys
        });
      }, _ => {});
  }

  handleAddApiKeyInit() {
    this.setState({
      modifying: false,
      creatingApiKey: false,
      creatingApiKeyError: null,
      addApiKeyModalShow: true
    });
  }

  handleAddApiKey = (apiKey) => {
    this.setState({
      modifying: true,
      creatingApiKey: true,
      creatingApiKeyError: null
    });

    // Create API key
    this.props.app.api.apiKeysTargetTargetIdPost(this.props.target, this.props.targetId, apiKey)
      .then(response => {
        this.setState({
          modifying: false,
          creatingApiKey: false,
          creatingApiKeyError: null,
          apiKey: response.data.api_key,
          apiKeyConfirmModalShow: true
        });

        // Refresh the list of API keys
        this.loadApiKeys();
      }, error => {
        // Indicate error. The API refuses some mints with an explanation the user needs — an org- or
        // blob-scoped key minted while acting as a service account would have no human behind it, and
        // the 400 says to mint it as yourself instead. That lives in the response body, so it is read
        // through Utils.errorMessage rather than off the axios error's generic .message.
        this.setState({
          modifying: false,
          creatingApiKey: false,
          creatingApiKeyError: Utils.errorMessage(error)
        });
      });
  }

  render() {
    return (
      <>
        <h5>API Keys</h5>
        <hr/>

        <div>
          API keys are used to provide unauthenticated actors access to targets.
        </div>

        {this.state.apiKeys && 0 !== this.state.apiKeys.length &&
          <div className="content-row">
            <Table hover bordered style={{"margin-bottom": "0px"}}>
              <tbody>
                {this.state.apiKeys.map((apiKey, _) => {
                  return (
                    <ApiKey
                      app={this.props.app}
                      apiKeysInterface={this.state}
                      apiKey={apiKey}
                    />
                  );
                })}
              </tbody>
            </Table>
          </div>
        }

        {!this.state.modifying &&
          <div className="content-row">
            <Button
              variant="success"
              size="sm"
              onClick={() => this.handleAddApiKeyInit()}><GoKey/> New
            </Button>

            <span className="text-muted text-note">
              &nbsp;&nbsp;&nbsp;Create key to make target accessible via API
            </span>
          </div>
        }

        {this.state.creatingApiKey &&
          <div className="content-row">
            <Alert variant="primary">
              Creating API key...
            </Alert>
          </div>
        }
        {this.state.creatingApiKeyError &&
          <div className="content-row">
            <Alert variant="warning">
              {this.state.creatingApiKeyError}
            </Alert>
          </div>
        }

        <AddApiKeyModal
          show={this.state.addApiKeyModalShow}
          onHide={() => this.state.setAddApiKeyModalShow(false)}
          handleAddApiKey={this.handleAddApiKey}
        />

        <ApiKeyConfirmModal
          show={this.state.apiKeyConfirmModalShow}
          onHide={() => this.state.setApiKeyConfirmModalShow(false)}
          apiKey={this.state.apiKey}
        />
      </>
    );
  }
}
